import AbstractController from '../../../Controller/AbstractController';
import Controller from '../../../Controller/Controller';
import TeaserSlider from '../Elements/TeaserSlider';

/**
 * Teaser Controller
 *
 * @class
 */
class TeaserController extends AbstractController {
  /**
   * @constructor
   */
  constructor() {
    super();

    Controller.registerController(this);
    this._registerElements(...TeaserSlider);
  }
}

export default new TeaserController();
